import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children, requireAdmin = false }) => {
  const { currentUser } = useAuth();

  // Check if user is authenticated
  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  // If admin access is required, check if user is an admin
  if (requireAdmin) {
    const allowedAdminEmails = [
      'oakandstonecabinets@gmail.com',
      'jadendficklin@gmail.com'
    ];

    if (!allowedAdminEmails.includes(currentUser.email)) {
      console.log('Unauthorized admin access attempt:', currentUser.email);
      return <Navigate to="/login" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
